import api from '../config/api';

// Event lookup for detail pages and the image-upload flow.
export const getEventDetails = async (id) => {
  const response = await api.get(`/events/detail/${encodeURIComponent(id)}`);
  return response.data;
};

/**
 * Join an event using invitation token
 * @param {string} token - Invitation token
 * @param {string} status - User's response status (accepted, declined, rejected)
 * @param {string} joinedVia - How user joined (link or qr_code)
 * @returns {Promise} - API response
 */
export const joinEvent = async (token, status = 'accepted', joinedVia = 'link') => {
  try {
    const response = await api.post(`/events/join/${token}`, {
      status: status,
      joined_via: joinedVia,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Get event details by invitation token (public endpoint)
 * @param {string} token - Invitation token
 * @returns {Promise} - Event details
 */
export const getEventByToken = async (token) => {
  try {
    // This would need a public endpoint on the backend
    // For now, we'll try to get it after user logs in
    const response = await api.get(`/events/invitation/${token}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
